export const ToolbarMenuItems = {
  CONTACT_SUPPORT: "Contact Support",
  LOGOUT: "Logout",
  CLOSE: "Close",
  GO_TO_PARENT_LOAN: "Go to Parent Loan",
  GO_TO_MERCHANT_APP: "Go to Merchant App",
  CHANGE_OFFICE: "Change Office"
};
